import { testimonialContent } from '@/mocks/seo-content';

export default function Testimonials() {
  return (
    <section className="bg-background-100 py-16 md:py-20">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="flex items-center justify-center gap-2 mb-4">
            <span className="w-2 h-2 rounded-full bg-accent-500"></span>
            <span className="text-xs text-foreground-500 font-medium uppercase tracking-wider">
              User Feedback
            </span>
          </div>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900">
            {testimonialContent.headline}
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            {testimonialContent.subheadline}
          </p>
        </div>

        {/* 3×2 Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {testimonialContent.reviews.map((review, i) => (
            <div
              key={i}
              className={`rounded-2xl bg-background-50 p-5 md:p-6 border border-background-200/60 transition-all duration-300 hover:border-background-300/80 ${
                i >= 3 ? 'opacity-50' : ''
              }`}
            >
              {/* Stars */}
              <div className="flex items-center gap-1 mb-3">
                {[...Array(5)].map((_, s) => (
                  <span key={s} className="w-4 h-4 flex items-center justify-center">
                    <i
                      className={`${
                        s < review.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'
                      } text-sm`}
                    ></i>
                  </span>
                ))}
              </div>
              {/* Headline */}
              <h4 className="text-sm font-semibold text-foreground-900 mb-2">
                {review.headline}
              </h4>
              {/* Body */}
              <p className="text-sm text-foreground-600 leading-relaxed">
                {review.text}
              </p>
              {/* User */}
              <div className="flex items-center gap-3 mt-4 pt-4 border-t border-background-200/60">
                <div className="w-10 h-10 rounded-full bg-secondary-200 flex items-center justify-center">
                  <span className="text-sm font-semibold text-secondary-700">
                    {review.name.charAt(0)}
                  </span>
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{review.name}</p>
                  <p className="text-xs text-foreground-500">{review.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}